__turbopack_context__.v({
  "navContainerMobile": "NavigationSidebar-module__Ia5e3W__navContainerMobile",
  "scrollShadowCollapsed": "NavigationSidebar-module__Ia5e3W__scrollShadowCollapsed",
  "scrollableContentMobile": "NavigationSidebar-module__Ia5e3W__scrollableContentMobile",
});
